// axios
import axios from 'axios'

// console.log(vue);
const domain = ''

export default axios.create({
  baseURL: localStorage.getItem('baseUrl') + '/graphql',
  domain
  // You can add your headers here
})
